module.exports = __webpack_public_path__ + "static/ha1-42a6dbd39f9bdec8206f4d6b992d540c.jpg";